export { unLazyLoad };

/**
 * Sets loading attribute of images in the initial window view to eager.
 */
const unLazyLoad = function unlazyLoadImagesInitView(){
  window.addEventListener( 'DOMContentLoaded', event => {
    const images = document.querySelectorAll( 'img' );
    const windowH = window.innerHeight;
    if ( images.length > 0 ) {

      images.forEach( thisImage => {
        let imgRec = thisImage.getBoundingClientRect();
        
        // Skip hidden images
        if( imgRec.top == imgRec.bottom ){
          return;
        }

        if ( imgRec.top < windowH && imgRec.bottom > -1 ) {
          thisImage.setAttribute( 'loading', 'eager' );
          thisImage.setAttribute( 'decoding', 'sync' );
					thisImage.setAttribute( 'fetchpriority', 'high' );
        }
      });
    }
  });
}